import { render } from "./OrgAddTrainee.vue?vue&type=template&id=07199ac4&scoped=true"
import script from "./OrgAddTrainee.vue?vue&type=script&lang=js"
export * from "./OrgAddTrainee.vue?vue&type=script&lang=js"

import "./OrgAddTrainee.vue?vue&type=style&index=0&id=07199ac4&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07199ac4"]])

export default __exports__